import queryString from "query-string";
import { ThunkDispatch } from "redux-thunk";

import { getBaseStore } from "@utils/configuration/aem";

import createApiModule from "@redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@redux/store.types";

import { StoreDetailsMapper } from "../stores/stores.mapper";
import {
    $PreferredStoreModuleName,
    TGetPreferredStoreByCodeRequest,
} from "./preferredStore.types";

const { actions } = createApiModule(
    $PreferredStoreModuleName,
    ({ url }) => `${url}`,
    {
        mapper: StoreDetailsMapper,
    },
);

export const getPreferredStoreByCode =
    (req: TGetPreferredStoreByCodeRequest) =>
    (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        const fullParams = {
            includeProductAvailability: !!req.sku,
            sku: req.sku,
            ...(req.includeProductAvailability && {
                includeProductAvailability: req.includeProductAvailability,
            }),
        };

        return dispatch(
            actions.load(
                {
                    path: {
                        url: `/storeservice/${getBaseStore()}/localized/stores/${
                            req.code
                        }?${queryString.stringify(fullParams)}`,
                    },
                },
                "GET",
            ),
        );
    };

export const clear = actions.clear;
export const refetch = actions.refetch;
